var render = function render(){
  var _vm$lawyer, _vm$lawyer$YoonYoungh;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function () {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Lawfirm taesung & P.E",
            "tabActive": "윤영환 대표 소개",
            "bg": "/images/sub/visual/sv-introduction.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "lawyer-view__head",
    attrs: {
      "tit": "윤영환 대표 소개",
      "titAdd": "Introduction",
      "titClass": "pb-0"
    },
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function () {
        return [_c('v-img', {
          staticClass: "text-bg w-100",
          attrs: {
            "src": "/images/sub/introduction/lawyer/lawyer-bg.svg",
            "max-width": "1840",
            "aspect-ratio": 1840 / 266
          }
        })];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "lawyer-view__body grey darken-3"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "7"
    }
  }, [_c('introduction-yoon-head')], 1), _c('v-col', {
    attrs: {
      "cols": "8",
      "sm": "5",
      "offset": "4",
      "offset-sm": "7",
      "offset-md": "0"
    }
  }, [_c('div', {
    staticClass: "lawyer-img-wrap"
  }, [_c('v-img', {
    staticClass: "lawyer-img w-100",
    attrs: {
      "data-aos": "fade-left",
      "src": "/images/lawyer/view/윤영환.png",
      "max-width": "586",
      "aspect-ratio": 586 / 900
    }
  })], 1)])], 1)], 1), _c('page-section', {
    staticClass: "lawyer-view__foot page-section--last page-section--xs"
  }, [_c('info-row', {
    attrs: {
      "title": "소개글",
      "topLine": ""
    }
  }, [_c('txt', {
    staticClass: "txt--dark line-height-17"
  }, [_c('p', [_vm._v("건축물 하자관리 분야에서는, 스프링클러 전면교체, 방화문 전면교체 판결 등은 물론 찾아보기 어려운 전선 전면교체, 승강기 전면교체 등의 성과를 이뤄 오고 있습니다.")]), _c('p', [_vm._v("또한 입주예정자협의회 지원 분야에서는, 기존의 명목뿐이었던 로펌의 역할을 파트너 지위로 끌어올렸다는 평가를 얻고 있으며 정비사업 분야에서는 시공사와 대등한 입장에서의 계약조율, 확실한 정산 소송 등의 업무를 진행하고 있습니다.")]), _c('p', [_vm._v("건설 실무가 출신의 변호사답게, 변호사, 기술자, 스태프들의 유기적인 소통과 조화를 이끌어 내어 단체소송, 집단소송에서 성과를 자랑하고 있습니다.")])])], 1), _vm._l((_vm$lawyer = _vm.lawyer) === null || _vm$lawyer === void 0 ? void 0 : (_vm$lawyer$YoonYoungh = _vm$lawyer.YoonYounghwan) === null || _vm$lawyer$YoonYoungh === void 0 ? void 0 : _vm$lawyer$YoonYoungh.info, function (item, index) {
    return _c('info-row', {
      key: index,
      attrs: {
        "title": item.title
      }
    }, _vm._l(item.infoDetail, function (detail, index) {
      return _c('info-detail', {
        key: index,
        class: index !== 0 ? 'mt-10px mt-md-16px' : ''
      }, [typeof detail === 'string' ? _c('span', [_vm._v(_vm._s(detail))]) : detail.bold ? _c('strong', [_vm._v(_vm._s(detail.txt))]) : _vm._e()]);
    }), 1);
  })], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }